import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";

import { routeTree } from "./routeTree.gen";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/lib/auth";
import { PersonaProvider } from "@/lib/persona";

import "./index.css";

// ----------------------------------------------------------------
// Router
// ----------------------------------------------------------------
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  context: {
    // Filled in at <RouterProvider /> via `context={{ queryClient }}`.
    queryClient,
  },
});

// Register router for type-safety.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// ----------------------------------------------------------------
// Bootstrap
// ----------------------------------------------------------------
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PersonaProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </PersonaProvider>
    </QueryClientProvider>
  </StrictMode>
);
